module.exports = __webpack_public_path__ + "img/katarina_bedrooms_21.e4056879.jpg";